import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    marginTop: theme.spacing(1),
    padding: theme.spacing(0, 2),

    '&> *+*': {
      marginLeft: theme.spacing(1),
    },
  },
  item: {
    alignItems: 'center',
    display: 'flex',
  },
  itemSign: {
    borderRadius: '50%',
    height: 8,
    width: 8,

    '&.high': { background: theme.palette.inventoryStatus.high },
    '&.low': { background: theme.palette.inventoryStatus.low },
    '&.empty': { background: theme.palette.inventoryStatus.empty },
  },
  itemText: {
    fontSize: 13,
    fontWeight: 'bold',
    marginLeft: theme.spacing(1),
  },
}));

export default () => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.item}>
        <div className={[classes.itemSign, 'high'].join(' ')} />
        <div className={classes.itemText}>庫存充足</div>
      </div>
      <div className={classes.item}>
        <div className={[classes.itemSign, 'low'].join(' ')} />
        <div className={classes.itemText}>即將完售</div>
      </div>
      <div className={classes.item}>
        <div className={[classes.itemSign, 'empty'].join(' ')} />
        <div className={classes.itemText}>銷售一空</div>
      </div>
    </div>
  );
};
